import useAsyncOptions from "./useAsyncOptions";
import { SearchAdminItem } from "../http/types/items";
import { useItemsApi } from "../http/useItems";

export type ItemOption = Pick<SearchAdminItem, "id" | "code" | "description">;

export const toItemOption = ({ id, code, description }: ItemOption): ItemOption => ({ id, code, description });

export const getItemOptionLabel = (option: ItemOption) => `${option.code} - ${option.description}`;

// Options of the item selects, fetching only the fields an option needs.
const useItemOptions = () => {
  const itemsApi = useItemsApi();

  return useAsyncOptions<ItemOption>(
    (query, signal) => itemsApi.getAdminItems(query, signal).then((items) => items.map(toItemOption)),
    { fields: ["id", "code", "description"] },
  );
};

export default useItemOptions;
